import a from 'axios'
import qs from 'qs'
import {V} from './variable.js'
import {G} from './index.js'
import { updateSmTokenByClient, executeProtocol, getRequestUrl, isInHeybox, showMessage} from '../utils'
import { HbToast } from '@heybox-components/heybox-ui'
import m from 'js-md5'
const authens = ['need_alipay_verify', 'need_phone_code', 'need_bind_phone', 'name_verify']
const REPORT_SM_DEVICE_ID_APIS = [
  '/account/open/login',
  '/account/open/get_login_code',
  '/account/open/login_with_code',
]

const A = a.create()
A.create = a.create
// POST传参序列化(添加请求拦截器)
A.interceptors[`${V[11]}${V[2]}${V[10]}${V[14]}${V[2]}${V[12]}${V[13]}`].use(
  async (config) => {
    // 在发送请求之前做某件事

    let p = {
      ...config.params
    }
    // 时间戳
    let t = ~~(+(G.w())/1000)

    // nonce生成
    let n = m(t + Math.random(new Date().getTime()).toString()).toLocaleUpperCase()
    // hkey
    p[`${V[4]}k${V[2]}y`]=G[V[3]](getRequestUrl(config[`${V[14]}${V[11]}l`].replace('/chatroom_xiaoheihe', ''), false), t, n)

    // _time
    p[`_${V[13]}${V[5]}${V[6]}${V[2]}`] = t

    // nonce
    p[`${V[7]}${V[8]}${V[7]}c${V[2]}`] = n
    config.params = p
    
    if (config.method === `${V[9]}${V[8]}${V[12]}${V[13]}`) {
      if (!config.upload) {
        config.data = {
          ...config.data
        }
        config.data = qs.stringify(config.data, { indices: false });
      }
    }
    config.withCredentials = true
    return config;
  },
  error => {
    return Promise.reject(error.message);
  }
)

A.interceptors[`${V[11]}${V[2]}${V[12]}${V[9]}${V[8]}${V[7]}${V[12]}${V[2]}`].use((res) => {
  let status_key = res.data[['s','t','a','t','u','s'].join('')]
  if (!res.config.params[['_', 'n', 'o', 't', 'i', 'p'].join('')]) {
    if (authens.indexOf(status_key) >= 0) {
      executeProtocol({
        protocol_type: 'openAuthentication',
        type: status_key
      })
    } else if (status_key == ["l", "a","c", "k", "_", "t", "o", "k", "e", "n"].join('')) {
      if (isInHeybox()) {
        updateSmTokenByClient().finally(() => {
          showMessage('failed', '请稍后刷新重试')
        })
      } else {
        window.dealSmDeviceId(() => {
          HbToast.error('请稍后刷新重试')
        })
      }
      
    } else if (status_key != 'ok' && res.data[['m','s','g'].join('')]) {
      if (res.data.msg.indexOf('数据上报失败') == -1) {
        showMessage('failed', res.data.msg)
      }
    }
  }
  return res
})

A.all = a.all
export default A